import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className = 'h-6 w-6' }) => (
  <span aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      {/* Green background */}
      <circle cx="12" cy="12" r="12" fill="#298842" />

      {/* White check */}
      <path
        d="M7.5 12.5l3 3 6-6"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export default Icon;
